<template>
  <div :class="[className, 'elemInput']">
    <label :for="fieldId">
      {{ label }}
    </label>
    <input :disabled="disabled" :id="fieldId" :type="type" v-model="value" />
    <span class="error">{{ error }}</span>
  </div>
</template>

<script>
// Сквозной счётчик, чтобы у каждого поля на странице был свой id
let instanceCount = 0;

export default {
  name: "elemInput",
  props: {
    disabled: {
      default: false,
    },
    elId: {
      default: null,
    },
    label: {
      default: null,
    },
    error: {
      default: null,
    },
    valueName: {
      default: null,
    },
    valueProp: {
      default: null,
    },
    className: {
      default: null,
    },
    type: {
      default: "text",
    },
  },
  data() {
    return {
      value: null,
      uid: ++instanceCount,
    };
  },
  computed: {
    // Явный elId имеет приоритет, иначе генерируем уникальный id,
    // чтобы label не цеплялся к первому полю на странице
    fieldId() {
      return this.elId || "elemInput-" + this.uid;
    },
  },
  watch: {
    valueProp(value) {
      this.value = value;
    },
    value(value) {
      this.$emit("changeValue", this.valueName, value);
    },
  },
  methods: {},
  created() {
    this.value = this.valueProp;
  },
};
</script>
